if(!customElements.get('sc-breadcrumbs')) {
  customElements.define('sc-breadcrumbs', class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.currentPageTitle = this.getAttribute('data-current-page-title');
      this.breadcrumbSplitter = this.getAttribute('data-breadcrumb-splitter') ?? '';
      this.maxCrumbs = this.getAttribute('data-max-crumbs') ?? 5;
      this.resourceType = this.getAttribute('data-resource-type') ?? '';
      this.resourceHandle = this.getAttribute('data-resource-handle') ?? '';
      this.defaultCollectionTitle = this.getAttribute('data-collection-title');
      this.defaultCollectionHandle = this.getAttribute('data-collection-handle');
      this.style.setProperty('--breadcrumb-separator', JSON.stringify(this.breadcrumbSplitter));
      this.initializeCrumbs();
      this.renderBreadcrumbs();
    }
    //In dev tools console tab, use: `document.querySelector('sc-breadcrumbs').logData()`
    logData() {
      console.log(this.breadcrumbsData);
      console.log(this.breadcrumbSplitter);
    }

    initializeCrumbs() {
      let pathReferrer = null;
      try {
        const refUrl = document.referrer ? new URL(document.referrer) : null;
        pathReferrer = (refUrl && refUrl.origin === window.location.origin) ? refUrl.pathname : null;
      } catch (_) {}

      const homeCrumb = { 
        title: 'Home', 
        url: '/', 
        resourceType: 'home', 
        resourceHandle: '/' 
      };
      const collectionsCrumb = { 
        title: 'Collections', 
        url: '/collections', 
        resourceType: 'list', 
        resourceHandle: 'collections' 
      };
      const max = parseInt(this.maxCrumbs, 10) || 5;
      const trail = [];
      
      switch (this.resourceType) {
        case 'index':
          trail.push(homeCrumb);
          break;
        case 'list-collections':
          trail.push(homeCrumb, collectionsCrumb);
          break;
        case 'collection':
          trail.push(homeCrumb, collectionsCrumb, {
            title: this.currentPageTitle,
            url: window.location.pathname,
            resourceType: 'collection',
            resourceHandle: this.resourceHandle
          });
          break;
        case 'product': {
          const hasCollections = this.getAttribute('data-product-has-collections') !== 'false';
          if (!hasCollections) {
            trail.push(homeCrumb, {
              title: this.currentPageTitle,
              url: window.location.pathname,
              resourceType: 'product',
              resourceHandle: this.resourceHandle
            });
          } else {
            let collectionTitle = this.defaultCollectionTitle;
            let collectionHandle = this.defaultCollectionHandle;
            if (pathReferrer) {
              const refCollectionMatch = pathReferrer.match(/^\/collections\/([^/?#]+)/);
              if (refCollectionMatch) {
                const refHandle = refCollectionMatch[1];
                const collectionsJson = this.getAttribute('data-product-collections');
                if (collectionsJson) {
                  try {
                    const productCollections = JSON.parse(collectionsJson);
                    const fromCollection = productCollections.find((c) => c.handle === refHandle);
                    if (fromCollection) {
                      collectionTitle = fromCollection.title;
                      collectionHandle = fromCollection.handle;
                    }
                  } catch (_) {}
                }
              }
            }
            trail.push(homeCrumb, collectionsCrumb);
            if (collectionTitle && collectionHandle) {
              trail.push(
                { title: collectionTitle, url: `/collections/${collectionHandle}`, resourceType: 'collection', resourceHandle: collectionHandle },
                { title: this.currentPageTitle, url: window.location.pathname, resourceType: 'product', resourceHandle: this.resourceHandle }
              );
            } else {
              trail.push({ title: this.currentPageTitle, url: window.location.pathname, resourceType: 'product', resourceHandle: this.resourceHandle });
            }
          }
          break;
        }
        default:
          trail.push(homeCrumb);
          if (this.currentPageTitle && window.location.pathname !== '/') {
            trail.push({ title: this.currentPageTitle, url: window.location.pathname, resourceType: this.resourceType || 'page', resourceHandle: this.resourceHandle || '' });
          }
      }

      this.breadcrumbsData = this.normalizeBreadcrumbsKeys(trail, max);
    }
    renderBreadcrumbs() {
      const values = Object.values(this.breadcrumbsData);
      const validIndices = [];
      for (let i = 0; i < values.length; i++) {
        const crumb = values[i];
        if (!crumb || typeof crumb !== 'object' || crumb.url == null) continue;
        validIndices.push(i);
      }
      const lastIndex = validIndices[validIndices.length - 1];
      const items = [];
      for (let i = 0; i < values.length; i++) {
        const crumb = values[i];
        if (!crumb || typeof crumb !== 'object' || crumb.url == null) continue;
        if (i === lastIndex) {
          items.push(`<li><span class="breadcrumb-link breadcrumb-current" aria-current="page">${crumb.title}</span></li>`);
        } else {
          items.push(`<li><a class="breadcrumb-link" href="${crumb.url}">${crumb.title}</a></li>`);
        }
      }
      const olHtml = `<ol>${items.join('')}</ol>`;
      const container = this.querySelector('.breadcrumbs');
      if (container) {
        container.innerHTML = olHtml;
        container.classList.remove('breadcrumbs-seo-fallback');
        container.removeAttribute('aria-hidden');
      } else {
        const nav = document.createElement('nav');
        nav.setAttribute('aria-label', 'Breadcrumb');
        const breadcrumbs = document.createElement('div');
        breadcrumbs.classList.add('breadcrumbs');
        breadcrumbs.innerHTML = olHtml;
        nav.appendChild(breadcrumbs);
        this.appendChild(nav);
      }
      this.setAttribute('data-is-loading', 'false');
    }
    normalizeBreadcrumbsKeys(values, max){
      // Always produce an object with keys 0, 1, 2, ... max-1 (no gaps). Use '' for empty slots so JSON.stringify keeps all keys.
      const maxCrumbs = parseInt(max, 10) || 5;
      const out = {};
      for (let i = 0; i < maxCrumbs; i++) {
        const v = values[i];
        out[i] = (v && typeof v === 'object' && v.url != null) ? v : '';
      }
      return out;
    }
  });
}